<template>
  <v-layout
    row
    wrap
  >
    <v-flex>
      <page-tile-title :has-back-button="true">
        <upload-image-dialog />
      </page-tile-title>
      <!-- end page-tile-title -->

      <v-layout
        v-if="items.length > 0"
        my-3
        row
        wrap
      >
        <v-flex
          v-for="(item, index) in items"
          :key="index"
          lg4
        >
          <v-card>
            <v-img
              :src="item.object_url"
              :lazy-src="item.object_url"
              aspect-ratio="1.7778"
            />
            <v-card-actions>
              <v-spacer />
              <delete-dialog :item="item" />
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout
        v-else
        my-3
        row
        wrap
      >
        <v-flex>
          <v-card>
            <v-card-text class="text-xs-center">
              No data available
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <!-- end flex -->
  </v-layout>
  <!-- end layout -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PageTileTitle from '@/components/Utilities/PageTileTitle'
import UploadImageDialog from './components/UploadImageDialog'
import DeleteDialog from './components/DeleteDialog'
export default {
  components: {
    PageTileTitle,
    DeleteDialog,
    UploadImageDialog
  },
  computed: {
    ...mapGetters({
      isLoading: 'blogGallery/isLoading',
      items: 'blogGallery/galleries'
    })
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  created () {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData()
  },
  methods: {
    ...mapActions({
      fetchData: 'blogGallery/getGalleries'
    })
  }
}
</script>
